import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "manualSpan"
}
const _hoisted_2 = { class: "flex justify-center items-center" }
const _hoisted_3 = {
  key: 2,
  class: "corner-flag absolute top-0 right-0 pl-2 h-5 flex flex-wrap flex-row-reverse w-3/4"
}
const _hoisted_4 = ["textContent"]
const _hoisted_5 = ["textContent"]
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "patient" }
const _hoisted_8 = { class: "text-sm text-gray-darker truncate" }
const _hoisted_9 = { class: "flagsWrapper" }
const _hoisted_10 = { class: "timestamps" }
const _hoisted_11 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_12 = { class: "text-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Avatar = _resolveComponent("Avatar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["queue-card rounded-tr-md", _ctx.borderColor]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
  }, [
    (_ctx.appointment.manual)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, "manual"))
      : _createCommentVNode("", true),
    (_ctx.newPatient)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "corner-flag absolute top-0 right-0 w-8 h-5",
          style: _normalizeStyle([{"padding-top":"2px"}, { paddingTop: _ctx.newPatient ? '2px' : '0px' }])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_icon, {
              color: "#F57A1F",
              size: 18
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.iconPath), 1)
              ]),
              _: 1
            })
          ])
        ], 4))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.doctors.slice(0, 3), (x, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: !!x ? x.uuid : i,
              class: "text-xs text-white font-bold text-center w-7 h-5",
              style: _normalizeStyle(_ctx.getInitialsStyle(x)),
              textContent: _toDisplayString(_ctx.getInitials(x))
            }, null, 12, _hoisted_4))
          }), 128)),
          (_ctx.doctors.length > 6)
            ? (_openBlock(), _createElementBlock("div", {
                key: "moreTagInQueue",
                class: "text-xs text-white font-bold text-center w-7 h-5",
                style: {backgroundColor: '#efefef', color: '#333333'},
                textContent: _toDisplayString(`+ ${_ctx.doctors.length - 5}`)
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.doctors.slice(3, 5), (x, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: !!x ? x.uuid : i,
              class: "text-xs text-white font-bold text-center w-7 h-5",
              style: _normalizeStyle(_ctx.getInitialsStyle(x)),
              textContent: _toDisplayString(_ctx.getInitials(x))
            }, null, 12, _hoisted_6))
          }), 128))
        ])),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_Avatar, {
        class: "mb-1",
        src: _ctx.imageUrl,
        alt: _ctx.name
      }, null, 8, ["src", "alt"]),
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.patientName(_ctx.name)), 1),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.appointment.has_traction_flags)
          ? (_openBlock(), _createBlock(_component_v_icon, {
              key: 0,
              color: "green-darken-2",
              size: 17
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("mdi-flag", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.appointment.has_flags)
          ? (_openBlock(), _createBlock(_component_v_icon, {
              key: 1,
              color: "red-darken-2",
              size: 17
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("mdi-flag", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.telehealthRoom)
          ? (_openBlock(), _createBlock(_component_v_icon, {
              key: 2,
              color: "red-darken-2",
              size: 17,
              title: "Online video visit"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("mdi-video", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.arrivalTime)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("span", {
              class: "absolute font-bold text-gray",
              style: _normalizeStyle({ color: _ctx.waitTimeTextColor })
            }, " Wait | ", 4),
            _createElementVNode("span", {
              class: "ml-10",
              style: _normalizeStyle({ color: _ctx.waitTimeTextColor })
            }, _toDisplayString(_ctx.waitTime) + _toDisplayString(_ctx.overHour ? 'm' : 's'), 5)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "absolute text-gray" }, " Appt | ", -1)),
        _createElementVNode("span", {
          class: _normalizeClass(["ml-10", _ctx.isMoreThanTenMinLate ? 'red--text' : ''])
        }, _toDisplayString(_ctx.$dayjs(_ctx.appointmentTime).format('h:mm A')), 3)
      ])
    ])
  ], 2))
}